import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { addFavouriteGame, removeFavouriteGame } from 'redux-thunk/thunk/game.thunk'
import { getAuthToken } from 'helpers/cookie.helpers'
import FavouriteIcon from 'components/molecules/FavouriteIcon/index'
import { openWarningToaster } from 'helpers/toaster.helpers'
import { GameImg } from 'pages/GameImage/index'
import { LOADER_HANDLER_TYPES } from 'constants/index'
import Loader from 'components/ui-kit/Loader/index'
import { defaultGameImage } from 'components/ui-kit/Icons/png/index'

const CasinoGameCard = (props) => {
  const { game, isFavourite = false } = props
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isLoggedIn = getAuthToken()
  const { gameTab } = useSelector(state => state?.lobby)
  const { [LOADER_HANDLER_TYPES.submit]: loading } = useSelector(state => state.loader)
  const [gameId, setGameId] = useState(null)

  const onGamePlayRedirect = useCallback((game) => {
    const gameName = game?.gameName?.toLowerCase().replace(/\s+/g, '-')
    if (isLoggedIn) {
      history?.push(`/casino/play-game/${gameName}`, { game, demo: false })
    } else if (game.hasDemo) {
      history?.push(`/casino/play-game/${gameName}`, { game, demo: true })
    } else {
      openWarningToaster({ message: t('LoginRequired') })
    }
  }, [])

  const handleFavouriteGame = (e) => {
    setGameId(game?.id)
    e.stopPropagation()
    if (game?.isFavourite || isFavourite) {
      dispatch(removeFavouriteGame({ game, gameTab }))
    } else {
      dispatch(addFavouriteGame({ game }))
    }
  }

  useEffect(() => {
    if (!loading) {
      setGameId(null)
    }
  }, [loading])

  return (
    <div className='theme-card-wrap'>
      <div className='theme-card'>
        <div className='casino-img-wrap'>
          <GameImg
            imgSrc={game?.image
              ? game?.image
              : defaultGameImage}
          />
          <div
            className='card-overlay'
            onClick={() => onGamePlayRedirect(game)}
          >
            <h4>Play Now</h4>
            <p>$1,130.33</p>
            {isLoggedIn &&
              <NavLink
                to='#'
                onClick={(e) => handleFavouriteGame(e)}
              >
                {(loading && gameId === game?.id)
                  ? <Loader variant={LOADER_HANDLER_TYPES.submit} />
                  : <FavouriteIcon fill={game?.isFavourite || isFavourite ? 'red' : 'none'} />}
              </NavLink>}
          </div>
        </div>
      </div>
    </div>

  )
}

export default React.memo(CasinoGameCard)
